import { render, staticRenderFns } from "./TextSlide.vue?vue&type=template&id=3d9ee89a&scoped=true&"
import script from "./TextSlide.vue?vue&type=script&lang=js&"
export * from "./TextSlide.vue?vue&type=script&lang=js&"
import style0 from "./TextSlide.vue?vue&type=style&index=0&id=3d9ee89a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9ee89a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d9ee89a')) {
      api.createRecord('3d9ee89a', component.options)
    } else {
      api.reload('3d9ee89a', component.options)
    }
    module.hot.accept("./TextSlide.vue?vue&type=template&id=3d9ee89a&scoped=true&", function () {
      api.rerender('3d9ee89a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/components/slides/TextSlide.vue"
export default component.exports